import { httpFetch } from "../../Utils/httpUtils";
import { customerActionTypes } from "../../ActionTypes/customerActionTypes";
import { commonActionTypes } from "../../ActionTypes/commonActionTypes";
import commonActions from "../commonActions";

const customerDiscountAgreementActions = {

    getCustomerDiscountAgreements(customerId, actionType = customerActionTypes.STORE_CUSTOMER_DISCOUNT_AGREEMENTS) {
        return (dispatch) => {
            dispatch({ type: commonActionTypes.SET_DATA_LOADING, key: "customerDiscountAgreements", value: true });
            return httpFetch(`/api/customerDiscountAgreement/${customerId}`, dispatch)
                .then(json => {
                    dispatch({ type: actionType, data: json });
                }).finally(() => {
                    dispatch({ type: commonActionTypes.SET_DATA_LOADING, key: "customerDiscountAgreements", value: false });
                })
        }
    },

    createCustomerDiscountAgreement(customerId, form, callback) {
        return (dispatch) => {

            const body = {
                discountAgreements: form.data.groupedDiscountAgreementIds.map(discountAgreementId => ({
                    discountAgreementId: discountAgreementId,
                    startDate: form.data.startDate,
                    endDate: form.data.endDate
                }))
            }

            const httpRequest = {
                method: 'POST',
                body: JSON.stringify(body)
            };

            dispatch({ type: commonActionTypes.SET_DATA_LOADING, key: "createCustomerDiscountAgreement", value: true });
            return httpFetch(`/api/customerDiscountAgreement/${customerId}`, dispatch, httpRequest)
                .then(json => {
                    if (callback)
                        callback(json);
                    dispatch(commonActions.showSuccess('Customer discount agreement has been created!'));
                }).finally(() => {
                    dispatch({ type: commonActionTypes.SET_DATA_LOADING, key: "createCustomerDiscountAgreement", value: false });
                })
        }
    },

    terminateCustomerDiscountAgreements(customerId, discountAgreements, callback) {
        return (dispatch) => {
            const httpRequest = {
                method: 'POST',
                body: JSON.stringify({ discountAgreements })
            };

            dispatch({ type: commonActionTypes.SET_DATA_LOADING, key: "terminateCustomerDiscountAgreement", value: true });
            return httpFetch(`/api/customerDiscountAgreement/${customerId}/terminate`, dispatch, httpRequest)
                .then(json => {
                    if (callback) callback(json);
                })
                .finally(() => {
                    dispatch({ type: commonActionTypes.SET_DATA_LOADING, key: "terminateCustomerDiscountAgreement", value: false });
                });
        };
    }

};

export default customerDiscountAgreementActions;
